/**
 * price-filter-available.js
 *
 * Shopify's native storefront price filter and sort consider ALL variant
 * prices, including out-of-stock ones. This script applies client-side:
 *
 * 1. Price range filter — hides products whose first-available-variant price
 *    (after PIX discount) is outside the selected range.
 * 2. Price sort — re-orders cards by first-available-variant price (after
 *    PIX discount) when sort_by=price-ascending or price-descending is active.
 *
 * Requires: product cards to have data-first-available-price (in cents).
 * PIX discount % is read from collection-filters-form[data-pix-discount].
 */

(function () {
  function getPixDiscount() {
    var el = document.querySelector('collection-filters-form[data-pix-discount]');
    if (!el) return 0;
    var pct = parseFloat(el.dataset.pixDiscount) || 0;
    if (pct < 0) pct = 0;
    if (pct > 100) pct = 100;
    return pct / 100;
  }

  function applyDiscount(price) {
    var discount = getPixDiscount();
    return Math.round(price * (1 - discount));
  }

  function getActivePriceFilter() {
    var params = new URLSearchParams(window.location.search);
    var gte = params.get('filter.v.price.gte');
    var lte = params.get('filter.v.price.lte');
    if (gte === null && lte === null) return null;
    return {
      min: gte !== null ? Math.round(parseFloat(gte) * 100) : null,
      max: lte !== null ? Math.round(parseFloat(lte) * 100) : null,
    };
  }

  function getActivePriceSort() {
    var params = new URLSearchParams(window.location.search);
    var sort = params.get('sort_by');
    if (sort === 'price-ascending') return 'asc';
    if (sort === 'price-descending') return 'desc';
    return null;
  }

  function applyPriceFilter() {
    var priceFilter = getActivePriceFilter();
    var cards = document.querySelectorAll('[data-first-available-price]');

    cards.forEach(function (card) {
      var rawPrice = parseInt(card.dataset.firstAvailablePrice, 10);
      var price = applyDiscount(rawPrice);
      var wrapper = card.closest('.m-product-item') || card.closest('.m\\:column') || card;

      if (priceFilter) {
        var belowMin = priceFilter.min !== null && price < priceFilter.min;
        var aboveMax = priceFilter.max !== null && price > priceFilter.max;
        if (belowMin || aboveMax) {
          wrapper.style.display = 'none';
          wrapper.setAttribute('data-price-hidden', '1');
        } else {
          wrapper.style.display = '';
          wrapper.removeAttribute('data-price-hidden');
        }
      } else {
        wrapper.style.display = '';
        wrapper.removeAttribute('data-price-hidden');
      }
    });
  }

  function applyPriceSort() {
    var sortDir = getActivePriceSort();
    if (!sortDir) return;

    var container = document.querySelector('[data-product-container]');
    if (!container) return;

    var wrappers = Array.from(container.querySelectorAll('[data-first-available-price]')).map(function (card) {
      return card.closest('.m-product-item') || card.closest('.m\\:column') || card;
    }).filter(function (el, idx, arr) {
      return arr.indexOf(el) === idx;
    });

    wrappers.sort(function (a, b) {
      var rawA = parseInt(a.querySelector('[data-first-available-price]').dataset.firstAvailablePrice, 10);
      var rawB = parseInt(b.querySelector('[data-first-available-price]').dataset.firstAvailablePrice, 10);
      var priceA = applyDiscount(rawA);
      var priceB = applyDiscount(rawB);
      return sortDir === 'asc' ? priceA - priceB : priceB - priceA;
    });

    wrappers.forEach(function (el) {
      container.appendChild(el);
    });
  }

  function applyAll() {
    applyPriceFilter();
    applyPriceSort();
  }

  applyAll();
  document.addEventListener('collection:rerendered', applyAll);
})();
